/**
 * The decisions the navigation guard makes, kept out of the guard itself so they can be tested
 * without instantiating a router and a Keycloak client.
 */

export type NavigationDecision = { type: "continue" } | { type: "home" } | { type: "login" };

/** Route names that only exist outside production. */
const TEXT_MANAGEMENT_ROUTES = ["TextMaintenance", "TextDiffs", "TextDependencies", "TextSearch"];

export type NavigationContext = {
    routeName?: string | null;
    requiresAuth: boolean;
    textManagementAvailable: boolean;
    authenticated: boolean;
    isAdmin: boolean;
};

export function decideNavigation({
    routeName,
    requiresAuth,
    textManagementAvailable,
    authenticated,
    isAdmin,
}: NavigationContext): NavigationDecision {
    if (routeName && TEXT_MANAGEMENT_ROUTES.includes(routeName) && !textManagementAvailable) {
        return { type: "home" };
    }

    // These two used to be combined with &&, so an authenticated user without the admin role walked
    // straight past the guard into pages that could only answer with 403s.
    if (requiresAuth && !(authenticated && isAdmin)) {
        // Sending a signed-in user without the role to the login screen would just loop them back.
        return authenticated ? { type: "home" } : { type: "login" };
    }

    return { type: "continue" };
}
